import { render, staticRenderFns } from "./MinMaxAvg.vue?vue&type=template&id=cd46ece2&"
import script from "./MinMaxAvg.vue?vue&type=script&lang=js&"
export * from "./MinMaxAvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports